// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"nba-z","subtitle":"oba-z","wrapper":"pba-z","leftArrow":"qba-z","rightArrow":"rba-z"};